import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

// searchString and value is used by nested Dropdown
// eslint-disable-next-line no-unused-vars
export const SingleText = ({children, searchString, value, onClick, disabled, infoText, cy}) => {
	const textColor = disabled && '#a1a1a1';

	return (
		<Container title={infoText}>
			<Text onClick={onClick} color={textColor} data-cy={cy} title={children}>
				{children}
			</Text>
		</Container>
	);
};

export const Container = Styled.div`
	background-color: transparent;
	padding: 5px 0;
	overflow: hidden;
`;

export const Text = Styled.p`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 0;
	margin: 0;
	font-size: 12px;
	color: ${props => props.color || '#545454'};
`;

SingleText.propTypes = {
	children: PropTypes.any,
	searchString: PropTypes.string,
	value: PropTypes.any,
	onClick: PropTypes.func,
	color: PropTypes.string,
	disabled: PropTypes.bool,
	infoText: PropTypes.string,
	cy: PropTypes.string,
};
